import React, {Fragment, useState} from "react";
import styles from "../../styles/contract.module.css"
import {useNavigate, useParams} from "react-router";
import {AiOutlineClose,AiOutlineDownload} from "react-icons/ai"
import {Form} from "react-bootstrap";
import {BiFontFamily} from "react-icons/bi"
import {BsPencil} from "react-icons/bs"
import {ggID} from "../../utils/contract-signing/helpers";
import {AttachmentTypes} from "../../utils/constants/contract";
import DefaultLoader from "../common/loaders/default-loader";
import returnCurrentContractColor from "../presentational/contract/return-current-contract-color";


const EditContractSidebar = ({contractData,usePdfFromParent,useAttachmentsFromParent,disableSignatureForSigner}) => {
    const navigate = useNavigate()
    const [currentColor,setCurrentColor] = useState(returnCurrentContractColor(contractData[0]?.label))
    const [currentSigner,setCurrentSigner] = useState(contractData[0]?.data[0]?._id)


    const {isSaving, savePdf} = usePdfFromParent
    const { allPageAttachments, add: addAttachment} = useAttachmentsFromParent

    const onAssignToChange = (e) => {
        const {id,label} = JSON.parse(e.target.value)

        setCurrentSigner(id)
        setCurrentColor(returnCurrentContractColor(label))
    }

    const addText = () => {
        const newTextAttachment = {
            id: ggID(),
            type: AttachmentTypes.TEXT,
            x: 20,
            y: 20,
            width: 100,
            editId:"",
            signerId:currentSigner,
            colorTheme:currentColor,
            isEditable:false,
            height: 40,
            size: 14,
            lineHeight: 1.4,
            fontFamily: 'Times-Roman',
            text: 'Initials', //empty if true
        };
        addAttachment(newTextAttachment);
    };
    const addSignature = () => {
        const newTextAttachment = {
            id: ggID(),
            type: AttachmentTypes.SIGNATURE,
            x: 20,
            y: 20,
            width: 100,
            editId:"",
            signerId:currentSigner,
            colorTheme:currentColor,
            isEditable:false,
            height: 40,
            size: 14,
            lineHeight: 1.4,
            fontFamily: 'Times-Roman',
            text: 'Sign',
        };
        addAttachment(newTextAttachment);
    }

    const addInitials = () => {
        const newTextAttachment = {
            id: ggID(),
            type: AttachmentTypes.INITIALS,
            x: 20,
            y: 20,
            width: 100,
            editId:"",
            signerId:currentSigner,
            colorTheme:currentColor,
            isEditable:false,
            height: 40,
            size: 14,
            lineHeight: 1.4,
            fontFamily: 'Times-Roman',
            text: 'Initials',
        };
        addAttachment(newTextAttachment);
    }


    const handleSavePdf = () => savePdf(allPageAttachments);
    return(
      <>
        <aside className={styles.sidebar__wrapper}>
            <div className={styles.close__button}>
                <button type={"button"} onClick={()=>navigate("/home")}><AiOutlineClose/></button>
            </div>
            <div className={styles.content__wrapper}>
                <div className={styles.content}>
                    <h6>Assign To</h6>
                    <Form.Select
                        name={"assignTo"}
                        onChange={onAssignToChange}
                        style={{color:currentColor}}
                    >
                        {contractData?.map((el,index) => (
                            <Fragment key={`${el?.label}_${index}`}>
                                {el?.data?.map(innerEl => (
                                    <Fragment key={innerEl?._id}>
                                        <option value={JSON.stringify({id:innerEl?._id,label:el?.label})}>{`${el?.label}: ${innerEl?.name}`}</option>
                                    </Fragment>
                                ))}
                            </Fragment>
                        ))}
                    </Form.Select>
                </div>
                <div className={styles.content}>
                    <h6>Fillable Fields</h6>
                    <div className={styles.content__button__wrapper}>
                        {/*<button type={"button"} style={{color:currentColor}} onClick={addText}>*/}
                        {/*    <BiFontFamily/>*/}
                        {/*    Text*/}
                        {/*</button>*/}
                        <button type={"button"} style={{color:currentColor}} onClick={addSignature} disabled={disableSignatureForSigner.includes(currentSigner)}>
                            <BsPencil/>
                            Sign
                        </button>
                        <button type={"button"} style={{color:currentColor}} onClick={addInitials}>
                            <BsPencil/>
                            Initials
                        </button>
                    </div>
                </div>
                <div className={styles.content}>
                    <h6>Download Contract</h6>
                    <div className={styles.content__button__wrapper}>
                        {isSaving && <DefaultLoader/>}
                        {!isSaving && <button type={"button"} style={{color: currentColor}} onClick={handleSavePdf}>
                            <AiOutlineDownload/>
                            Save
                        </button>}
                    </div>
                </div>
            </div>
        </aside>
      </>
  )
}
export default EditContractSidebar
